import Head from 'expo-router/head';

import { DeliveryAddressModal } from '@fhs-legacy/frontend/src/components/address-modal';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function DeliveryAddressPage() {
  return (
    <>
      <Head>
        <title>Delivery Address - Firehouse Subs</title>
      </Head>
      <DeliveryAddressModal />
    </>
  );
}
